import React from "react";
import CEISTable from "./CEISTable/CEISTable";

export default function CEISCard(props) {
    const { ceis_data } = props
    const hasSource = Object.keys(ceis_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                CEIS - Match encontrado
            </p>
            <CEISTable ceis_data={ceis_data.source} />
        </div>
    )
}
